import {
  CanDownloadContext,
  CanGenerateByOneflowContext,
  CanPreviewContext,
  CanSendToOneflowContext,
  GetOneflowTemplateIdContext,
  IConsultantContractStrategy
} from "../consultant-contract-strategy";

export class ConfirmationContractStrategy implements IConsultantContractStrategy {
  public readonly name = "ConfirmationContractStrategy";

  canPublishToOneflowDirectly(ctx: CanSendToOneflowContext): boolean {
    return false;
  }

  canPublishToOneflowViaTicket(ctx: CanSendToOneflowContext): boolean {
    return false;
  }

  getOneflowTemplateId(ctx: GetOneflowTemplateIdContext) {
    return null;
  }

  getOneflowGeneratorType(ctx: CanGenerateByOneflowContext) {
    return null;
  }

  canDuplicate(): boolean {
    return true;
  }

  canEdit(): boolean {
    return true;
  }

  canPreview(ctx: CanPreviewContext): boolean {
    return true;
  }

  canDownload(ctx: CanDownloadContext): boolean {
    return !!ctx.fileId
  }

  defaultSalaryChoice(): null {
    return null;
  }
}
